import { Directive, ElementRef, Input, OnInit } from '@angular/core';
import { LanguageSettings } from '../providers/languageSettings.service';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[decorate]'
})
export class DecorateDirective implements OnInit {

  private codeElement: HTMLDivElement;

  constructor(el: ElementRef, private languageSettings: LanguageSettings) {
    this.codeElement = el.nativeElement;
    // this.parent = parent;
  }

  @Input('decorate') name: string;
  @Input() parent: object;

  ngOnInit() {
    this.languageSettings.getLanguageChangeEmitter().subscribe(
      language => this.onValChange(language)
    );
    this.onValChange(this.languageSettings.getSelectedLanguage());
  }

  onValChange(language: string) {
    this.codeElement.innerHTML = this.parent[language + this.name + 'Prism'];
    this.codeElement.className = 'language-' + language.toLowerCase();
  }

}
